var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7793 8.71978L2.28223 0.471246C2.05488 0.332226 1.79461 0.256288 1.52817 0.251245C1.26174 0.246203 0.998778 0.312238 0.766338 0.442557C0.533898 0.572875 0.340376 0.762771 0.205685 0.992705C0.0709935 1.22264 -2.87052e-06 1.48431 0 1.75079V18.2493C0.000216825 18.5157 0.0713501 18.7772 0.206092 19.0071C0.340835 19.2369 0.534328 19.4266 0.766693 19.5569C0.999057 19.6872 1.26192 19.7533 1.52826 19.7483C1.79461 19.7434 2.05484 19.6677 2.28223 19.5289L15.7793 11.2803C15.9986 11.1462 16.1797 10.9581 16.3054 10.7339C16.4311 10.5098 16.4971 10.2571 16.4971 10.0001C16.4971 9.74305 16.4311 9.49035 16.3054 9.26618C16.1797 9.042 15.9986 8.85386 15.7793 8.71978Z",
    fill: "#081D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayArrow);
export default __webpack_public_path__ + "static/media/PlayArrow.e12a30f12534244918c57ffcac94bf9e.svg";
export { ForwardRef as ReactComponent };